<template>
  <div class="out-room-item">
    <div class="out-room-head">
      <img src="@/assets/images/goods/new-arrival_2x.png" alt="" srcset="" class="w-18">
      <span>{{ newinData.title }}</span>
    </div>
    <div class="out-room-container">
      <div
        v-for="i in newinData?.goodsItemList"
        :key="i.goodsId"
        class="pr-10 cursor-pointer"
        @click="handleClick(i)"
      >
        <img :src="i.imgUrl" class="size-68 object-cover rounded-8" />
        <div class="text-10 font-600 c-#333 text-center">
          {{ formatPrice(i.price) }}
        </div>
      </div>
      <div>
        <div
          class="w-68 text-14 font-600 text-center cursor-pointer"
          @click="handleClick()"
        >
          {{ t("message.view_more") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {useI18n} from "vue-i18n";
import {useSetting} from "@/composables/use-setting";
// import {useNewinStore} from "@/states/newin";
import type {marketingType, goodsItemType} from "@/states/newin";
import {navigateTo, logAFEvent} from "@voghion/native-api";

// const emit = defineEmits(["reconnect"]);
const props = defineProps<{newinData: marketingType}>();

const {t} = useI18n();
const {formatPrice} = useSetting();
// const newinStore = useNewinStore();

const handleClick = (goods?: goodsItemType) => {
  // newinStore.clearUnread();
  // newinStore.clearMarketingUnread();
  if (goods && goods.routeUrl) {
    navigateTo({url: goods.routeUrl});
  } else if (props.newinData.skipUrl) {
    navigateTo({url: props.newinData.skipUrl});
  }

  if (props.newinData) {
    logAFEvent({
      event: "clickSPM",
      spm: "01010430401",
      spmName: "messageNewIn",
    });
  }
};
</script>

<style lang="scss" scoped>
.out-text-ellipsis {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.out-room-item {
  min-height: 60px;
  padding: 0 8px;
  .out-room-head {
    display: flex;
    align-items: center;
    padding: 10px 0;
    font-weight: bolder;
    font-size: 14px;
    color: #212121;
    line-height: 16px;
    font-style: italic;
  }

  .out-room-container {
    display: flex;
    align-items: center;
    margin-top: 4px;
    overflow-x: scroll;
  }
}
</style>
